var React = require('react');

function Cta1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"subscribe-1"),React.createElement("g",{"id":"a7988213-07f2-4e47-bd02-305331646122","data-name":"Layer 2","key":1},React.createElement("g",{"id":"2cb6716b-362d-4caa-a45c-e029c6785895","data-name":"pattern"},React.createElement("polygon",{"points":"360.62 106.59 360.61 106.59 254.02 0 217.42 36.6 298.86 118.04 0 118.04 0 169.8 297.4 169.8 217.43 249.78 254.03 286.38 397.21 143.19 360.62 106.59","fill":"#072f51","opacity":"0.31"})))]);
}

Cta1.defaultProps = {"viewBox":"0 0 397.22 286.38"};

module.exports = Cta1;

Cta1.default = Cta1;
